import api from './api';

// Get all public celeb updates
export const getCelebUpdates = async (params = {}) => {
  const response = await api.get('/celeb-updates', { params });
  return response.data;
};

// Get single celeb update
export const getCelebUpdate = async (id) => {
  const response = await api.get(`/celeb-updates/${id}`);
  return response.data;
};

// Get all celeb updates (admin)
export const getAdminCelebUpdates = async (params = {}) => {
  const response = await api.get('/celeb-updates/admin/all', { params });
  return response.data;
};

// Create celeb update
export const createCelebUpdate = async (data) => {
  const response = await api.post('/celeb-updates', data);
  return response.data;
};

// Update celeb update
export const updateCelebUpdate = async (id, data) => {
  const response = await api.put(`/celeb-updates/${id}`, data);
  return response.data;
};

// Delete celeb update
export const deleteCelebUpdate = async (id) => {
  const response = await api.delete(`/celeb-updates/${id}`);
  return response.data;
};

// Purchase celeb update
export const purchaseCelebUpdate = async (id) => {
  const response = await api.post(`/celeb-updates/${id}/purchase`);
  return response.data;
};

// Get my purchased celeb updates
export const getMyPurchasedCelebUpdates = async () => {
  const response = await api.get('/celeb-updates/purchases/my-purchases');
  return response.data;
};

// Get purchased celeb update details with link
export const getPurchasedCelebUpdateDetails = async (purchaseId) => {
  const response = await api.get(`/celeb-updates/purchases/${purchaseId}`);
  return response.data;
};

export default {
  getCelebUpdates,
  getCelebUpdate,
  getAdminCelebUpdates,
  createCelebUpdate,
  updateCelebUpdate,
  deleteCelebUpdate,
  purchaseCelebUpdate,
  getMyPurchasedCelebUpdates,
  getPurchasedCelebUpdateDetails
};
